<template>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="py-5 text-2xl font-bold">
            Inserimento dati contabilità generali
        </div>

        <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
             class="text-white p-3 mb-3 flex justify-between items-center">
            {{ response_message }}
            <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
        </div>

        <div class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 ">
            <p class="font-bold pb-2 text-sm">Tipologia</p>
            <p class="font-bold pb-2 text-sm">Alla data</p>
            <p class="font-bold pb-2 text-sm">Valore</p>
            <p class="w-8">&nbsp;</p>
        </div>

        <div v-for="(contabilita, i) in contabilita" :key="i"
             class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3">
            <div class="flex flex-col">
                <Field :label-visible="false" :errors="getContabilitaErrors(i,'contabilita', 'tipologia')">
                    <VueMultiselect
                        :options="tipologiaContabilita.options"
                        @search-change="tipologiaContabilita.search"
                        track-by="id"
                        label="descrizione"
                        v-model="contabilita.tipologia_contabilita"
                        placeholder="Tipologia"
                        class="next-vue-multiselect-single"
                        :internal-search="false"
                        :close-on-select="true"
                        :clear-on-select="true">
                    </VueMultiselect>
                </Field>
            </div>
            <div class="flex flex-col">
                <Field :label-visible="false" :errors="getContabilitaErrors(i,'contabilita', 'data')">
                    <input v-model="contabilita.data" type="date"
                           class="p-7px bg-next-gray-md-dark hover:bg-white">
                </Field>
            </div>
            <div class="flex flex-col">
                <Field :label-visible="false" :errors="getContabilitaErrors(i,'contabilita', 'valore')">
                    <input v-model="contabilita.valore" type="number" step="0.01"
                           class="p-7px bg-next-gray-md-dark hover:bg-white">
                </Field>
            </div>
            <div class="flex items-center">
                <NextButton variant="outline-secondary" @click="remove(i)"
                            class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i>
                </NextButton>
            </div>

        </div>
        <div class="flex justify-end">
            <NextButton variant="primary" @click="add"
                        class="col flex justify-center items-center h-8 w-8"><i class="icon-croce_quadrata"></i>
            </NextButton>
        </div>
        <div class="flex pt-3 justify-end">
            <NextButton class="px-3 py-2" @click="saveContabilita">Salva</NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import Alert from "@/components/Alert.vue";
import {mapState} from "vuex";
import businessUnits from "@/api/BusinessUnits";
import Autocomplete from "@/setup/Autocomplete";
import tipologiaContabilitaManager from "@/api/TipologiaContabilitaManager";
import {aziendeGruppoManager} from "@/api/AziendeGruppo";

@Options({
    name: 'ContabilitaAzienda',
    components: {
        Alert,
        Field,
        NextButton,
        Loading
    },
    computed: {
        ...mapState(
            ['permissions']
        )
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
    }
})
export default class ContabilitaAzienda extends Vue {
    tipologiaContabilita: any = setup(() => Autocomplete(tipologiaContabilitaManager, true))

    id!: number
    permissions!: any
    businessUnits = []
    buByLabel: any = {}
    contabilita: any[] = []
    errors: any = {}
    response_message = ''
    contabilitaErrors: any = {}
    esito = false

    getContabilitaErrors(index: string | number, prefix: string, field: string) {
        return (this.contabilitaErrors as any)[`${prefix}.${index}.${field}`]
    }

    created() {
        this.fetchContabilita()
        businessUnits.list().then((response: any) => {
            this.businessUnits = response.data

            this.businessUnits.reduce((acc: any, bu: any) => {
                acc[bu.label.toString().toLowerCase()] = bu
                return acc
            }, this.buByLabel)
        })
    }

    fetchContabilita() {
        aziendeGruppoManager.contabilita(this.id).then((response) => {
            this.contabilita = response.data
        })
    }

    saveContabilita() {

        const data = {contabilita: this.contabilita.map((e: any) => {
                return {
                    ...e,
                    tipologia_contabilita_aziende_gruppo_id: e.tipologia_contabilita ? e.tipologia_contabilita.id : null,
                }
            })}
        aziendeGruppoManager.saveContabilita(this.id, data).then(() => {
            this.esito = true
            this.contabilitaErrors = {}
            this.response_message = 'Salvataggio avvenuto corretamente'
        }).catch((res: any) => {
            this.esito = false
            this.response_message = 'Salvataggio fallito'
            if (res.response.status == 422) {
                this.contabilitaErrors = res.response.data.errors
            }
        });
    }

    remove(idx: number) {
        this.contabilita.splice(idx, 1)
    }

    add() {
        this.contabilita.push({id: null, tipologia_contabilita_aziende_gruppo: null,tipologia_contabilita:null, data: null, valore: 0})
    }

    get buLabelFromFascePermission() {
        let ret: any[] = []
        if (this.permissions) {
            for (let p in this.permissions) {
                const m = p.match('bu\.([a-zA-Z0-9]+)\.fasce_ricavo')
                if (m && m.length == 2) {
                    ret.push(this.buByLabel[m[1].toString().toLowerCase()])
                }
            }
        }
        return ret
    }

    get buLabelFromBilanciPermission() {
        let ret: any[] = []
        if (this.permissions) {
            for (let p in this.permissions) {
                const m = p.match('bu\.([a-zA-Z0-9]+)\.bilanci')
                if (m && m.length == 2) {
                    ret.push(this.buByLabel[m[1].toString().toLowerCase()])
                }
            }
        }
        return ret
    }


}

</script>
